// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"cf8b3e62","630":"79ff4c2c","799":"c5105d73"}[chunkId] + ".chunk.js";
};